import { render, staticRenderFns } from "./RouterLinkBack.vue?vue&type=template&id=5a2d5636"
import script from "./RouterLinkBack.vue?vue&type=script&lang=js"
export * from "./RouterLinkBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports